import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-signup-user-details',
  templateUrl: './signup-user-details.component.html',
  styleUrls: ['./signup-user-details.component.scss'],
})
export class SignupUserDetailsComponent implements OnInit {
  @Input() isStandaloneMode: any = false;
  @Input() modalLabel: any = 'User details';

  commentForm!: FormGroup;
  userDetails: any;
  data: any;
  statusOptions: any; // Will be populated from modal initialState
  selectedStatus: any;
  showCommentBox: boolean = false;
  isStatusChanged: boolean = false;
  @Output() editUser = new EventEmitter<{ comment: string; id: any; statusId: any }>();
  buttonText: string = 'Save';

  constructor(
    private modal: CustomModalService,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private toaster: ToastrService
  ) {}

  ngOnInit() {
    this.initializeModalMode();
    this.initializeForm();
  }

  private initializeModalMode() {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'] ?? this.modalLabel;
    this.data = this.modal?.modalService?.config?.initialState?.['userData'];
    this.statusOptions = this.data.list;

    this.userDetails = this.data?.data ?? this.data;

    if (this.data?.statusId >= 0) {
      this.selectedStatus = this.data.statusId;
    }
  }

  private initializeForm() {
    this.commentForm = this.fb.group({
      comment: [this.data?.comment ?? '', Validators.required],
    });
  }

  onStatusChange(event: any) {
    this.isStatusChanged = true;

    if (event?.id === 2) {
      this.showCommentBox = true;
      this.commentForm.get('comment')?.setValidators([Validators.required]);
      this.commentForm.get('comment')?.updateValueAndValidity();
      this.buttonText = 'Reject';
    } else if (event?.id === 1) {
      this.showCommentBox = false;
      this.commentForm.get('comment')?.clearValidators();
      this.commentForm.get('comment')?.setValue('');
      this.commentForm.get('comment')?.updateValueAndValidity();
      this.buttonText = 'Approve';
    } else {
      this.showCommentBox = false;
      this.commentForm.get('comment')?.clearValidators();
      this.commentForm.get('comment')?.setValue('');
      this.commentForm.get('comment')?.updateValueAndValidity();
      this.buttonText = 'Save';
    }
  }

  onUpdate() {
    const commentControl = this.commentForm.get('comment');
    const trimmedComment = commentControl?.value?.trim() ?? '';
    const isCommentRequired = this.selectedStatus === 2;

    if (isCommentRequired) {
      commentControl?.setValue(trimmedComment, { emitEvent: false });

      if (!trimmedComment) {
        commentControl?.setErrors({ required: true });
        this.commentForm.markAllAsTouched();
        return;
      }
    }

    this.callUpdateAPI(this.selectedStatus, trimmedComment);
  }

  private callUpdateAPI(statusData: any, comment: string) {
    const payload = {
      statusId: statusData,
      id: this.data?.id,
      comment: comment,
    };
    this.editUser.emit(payload);
  }
  onClose() {
    this.modal.close();
  }

  get isUpdateDisabled(): boolean {
    return !this.isStatusChanged || (this.showCommentBox && this.commentForm.invalid);
  }
}
